import React, { useEffect } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import {
  decodeOrganizedTourDealId,
  logOrgTourRouteLegacyRedirect,
  orgTourProfileDashboardPath,
} from "../../../utils/organizedTourRoutes";

/** Legacy path with deal id in URL segment — forward to canonical dashboard profile. */
export default function OrganizedTourLegacyDealProfileRedirect() {
  const { dealId: raw } = useParams();
  const location = useLocation();
  const dealId = decodeOrganizedTourDealId(raw);
  const to = orgTourProfileDashboardPath(dealId);

  useEffect(() => {
    logOrgTourRouteLegacyRedirect(location.pathname, to, "legacy_profile_deal_id");
  }, [location.pathname, to]);

  if (!dealId) {
    return <Navigate to="/p/dashboard/searchoffer" replace />;
  }

  return <Navigate to={to} replace />;
}
